import { useMissionsTranslation } from '../../../../ui/hooks';
import React from 'react';
import { AddHoursButton } from './AddHoursButton';
import { ApprovedHoursStatus } from './ApprovedHoursStatus';
import { DeniedNoShowHoursStatus } from './DeniedNoShowHoursStatus';
import { PendingHoursStatus } from './PendingHoursStatus';
export const VolunteeringHoursStatus = ({ participation, onAddHours }) => {
    const { t } = useMissionsTranslation();
    const hourStatus = participation.columns.hoursStatus;
    switch (hourStatus) {
        case 'deniedNoShow':
            return React.createElement(DeniedNoShowHoursStatus, null);
        case 'deniedInaccurate':
        case 'addHours':
            return (React.createElement(AddHoursButton, { missionName: participation.columns.missionName, missionOrganizationSharing: participation.columns.organizationSharing, shiftId: participation.columns.shiftId, participationId: participation.id, dialogContentOverride: t('timeTracking.addHoursDialog.contentTextSelf', {
                    date: t('date', { value: participation.columns.shiftStartTime }),
                    startTime: t('time', { value: participation.columns.shiftStartTime }),
                    endTime: t('time', { value: participation.columns.shiftStopTime }),
                }), onAddHours: onAddHours, shiftStartTime: participation.columns.shiftStartTime, shiftStopTime: participation.columns.shiftStopTime, participantShiftStartTime: participation.columns.hoursFrom, participantShiftStopTime: participation.columns.hoursTo }));
        case 'pending':
            return React.createElement(PendingHoursStatus, null);
        case 'approved':
            return React.createElement(ApprovedHoursStatus, null);
        default:
            return React.createElement(React.Fragment, null, hourStatus);
    }
};
